<div class='row h-100 align-items-center justify-content-center'>
  <div class='col-12 h-100 text-center d-flex align-items-center justify-content-center'>
    <div class='row text-center mb-2'>
      <img src='assets/images/loading.gif' class='loading-img'/>
    </div>
  </div>
</div>
